/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progression_Linear_Load_IncreaseInputs */

const en_us2_progression_linear_load_increase = /** @type {(inputs: Progression_Linear_Load_IncreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load goes up`)
};

const pt_br2_progression_linear_load_increase = /** @type {(inputs: Progression_Linear_Load_IncreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carga sobe`)
};

const es_419_progression_linear_load_increase = /** @type {(inputs: Progression_Linear_Load_IncreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El peso sube`)
};

const pt_pt2_progression_linear_load_increase = /** @type {(inputs: Progression_Linear_Load_IncreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carga sobe`)
};

const fr_fr2_progression_linear_load_increase = /** @type {(inputs: Progression_Linear_Load_IncreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La charge augmente`)
};

const de_de2_progression_linear_load_increase = /** @type {(inputs: Progression_Linear_Load_IncreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Gewicht steigt`)
};

const it_it2_progression_linear_load_increase = /** @type {(inputs: Progression_Linear_Load_IncreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il carico sale`)
};

/**
* | output |
* | --- |
* | "Load goes up" |
*
* @param {Progression_Linear_Load_IncreaseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_linear_load_increase = /** @type {((inputs?: Progression_Linear_Load_IncreaseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Linear_Load_IncreaseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_linear_load_increase(inputs)
	if (locale === "es-419") return es_419_progression_linear_load_increase(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_linear_load_increase(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_linear_load_increase(inputs)
	if (locale === "de-DE") return de_de2_progression_linear_load_increase(inputs)
	if (locale === "it-IT") return it_it2_progression_linear_load_increase(inputs)
	return en_us2_progression_linear_load_increase(inputs)
});
export { progression_linear_load_increase as "progression.linear_load_increase" }